import type { CommentBodyPartInfoCollapseData } from "./commentBody.util.types";
import { wrapChildren, wrapElement } from "~/units/dom";

const listNodeTypeName = "collapsible_list";
const itemNodeTypeName = "collapsible_list_item";
const headerNodeTypeName = "collapsible_list_item_header";

const listNodeTypeNameOLD = "collapsible_list__arguments";
const itemNodeTypeNameOLD = "collapsible_list_item__arguments";
const headerNodeTypeNameOLD = "collapsible_list_item_header__arguments";

export const ARGUMENT_DATA_TAG = "data-argumentSection";
export const ARGUMENT_DETAIL_CONTENT_TAG = "data-detailContent";

export function transformNodeToCommentBodyPartCollapseInfo(
  node: Element,
): CommentBodyPartInfoCollapseData {
  const items = [
    ...node.querySelectorAll(
      `[data-node-type="${itemNodeTypeName}"], [data-node-type="${itemNodeTypeNameOLD}"]`,
    ),
  ].map((itemElement, index) => {
    const title = itemElement
      .querySelector(
        `[data-node-type="${headerNodeTypeName}"], [data-node-type="${headerNodeTypeNameOLD}"]`,
      )
      ?.outerHTML.trim();
    const content = itemElement
      .querySelector(`[${ARGUMENT_DETAIL_CONTENT_TAG}]`)
      ?.outerHTML.trim();
    const badgeValue = String(index + 1);

    return {
      title,
      content,
      badgeValue,
    };
  });
  // TODO: Maybe the content editors should supply the "Arguments" title,
  //  rather than injecting it automatically here? Then we give them a more generic tool, like "collapsible list"
  //  instead of the very use-case-specific "arguments list" tool.
  return { items, title: node.getAttribute("data-list-title") ?? "Arguments" };
}

/**
 * Transform the collapsible lists in the given body DOM tree.
 *
 * TODO: This should probably be done by the content editors, not by the frontend.
 *
 * @param window
 *   The window object. In a browser, just use `window`. In Node, use something like JSDOM.
 * @param body
 *   The body DOM.
 */
export function transformList(
  window: Window & typeof globalThis,
  body: HTMLElement,
): void {
  body
    .querySelectorAll(
      `[data-node-type="${listNodeTypeName}"], [data-node-type="${listNodeTypeNameOLD}"]`,
    )
    .forEach((listElement) => {
      listElement
        .querySelectorAll(
          `[data-node-type="${itemNodeTypeName}"], [data-node-type="${itemNodeTypeNameOLD}"]`,
        )
        .forEach((itemElement) => {
          const headerElement = itemElement.querySelector(
            `[data-node-type="${headerNodeTypeName}"], [data-node-type="${headerNodeTypeNameOLD}"]`,
          );

          const summary = window.document.createElement("summary");
          if (headerElement) {
            wrapElement(window, headerElement, summary);
          }

          const details = window.document.createElement("details");
          wrapChildren(window, itemElement, details);
          const detailContent = window.document.createElement("div");
          detailContent.setAttribute(ARGUMENT_DETAIL_CONTENT_TAG, "true");

          wrapChildren(window, details, detailContent);

          if (summary) {
            details.appendChild(summary);
          }
        });

      listElement.setAttribute(ARGUMENT_DATA_TAG, "true");
    });
}
